import { NeutralColors } from "../../constants/colors";
import { BackdropLayout, CopyVariant, Variant } from "./types";
export var defaultProps = {
  variant: Variant.Default,
  copyVariant: CopyVariant.Default,
  onLinkClick: function onLinkClick() {},
  backdropLayout: BackdropLayout.Vertical,
  backdropColor: NeutralColors.Grey100,
  media: null,
  smallMedia: null
};